import useSWR from "swr";
import axios from "axios";

function useAllocations({ shouldFetch = true, labourerId, projectId, startDate, endDate, page, perPage, sortField, sortOrder }) {
  return useSWR(
    shouldFetch ?
      [
        `${process.env.REACT_APP_API_URL}/allocations`,
        labourerId, projectId, startDate, endDate, page, perPage, sortField, sortOrder
      ]
      : null,
    async ([url, labourerId, projectId, startDate, endDate, page, perPage, sortField, sortOrder]) => {
      const searchParams = new URLSearchParams();

      if (labourerId) searchParams.append('labourer', labourerId);
      if (projectId) searchParams.append('project', projectId);
      if (startDate) searchParams.append('startDate', startDate);
      if (endDate) searchParams.append('endDate', endDate);
      if (page) searchParams.append('page', page);
      if (perPage) searchParams.append('perPage', perPage);
      if (sortField) searchParams.append('sortField', sortField);
      if (sortOrder) searchParams.append('sortOrder', sortOrder);

      const params = searchParams.toString();

      const { data: { allocations, count } } = await axios.get(`${url}?${params}`);

      return { allocations, count };
    });
}

export default useAllocations;
